import script from "./CustomListEmpty.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomListEmpty.vue?vue&type=script&setup=true&lang=ts"

import "./CustomListEmpty.vue?vue&type=style&index=0&id=643a9142&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-643a9142"]])

export default __exports__